<template>
  <div class="copy-order-person rj-page-card" style="min-height: 150px">
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配权限员工:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="userNameYet">
                  <el-select v-model="form.userNameYet" placeholder="请选择" @change="changeUserName">
                    <el-option
                      v-for="item in existenceOrderPersonList"
                      :key="item.userName"
                      :label="item.userName"
                      :value="item.userId"
                      :loading="exitLoading"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tableData.length>0" v-loading="tableLoading" class="tableBody">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column type="index" width="60" label="序号" align="left" />
            <el-table-column prop="userName" label="员工姓名" align="left" />
            <el-table-column prop="deptName" label="部门" align="left" />
            <el-table-column prop="areaName" label="地区" align="left" />
            <el-table-column prop="areaName" label="类型" align="left" />
          </el-table>
        </div>
        <div class="rj-row">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                可分配权限员工:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="userName">
                  <el-select v-model="form.userName" clearable placeholder="请选择">
                    <el-option
                      v-for="item in orderPersonList"
                      :key="item.userId"
                      :label="item.userName"
                      :value="item.userName"
                      :loading="loading"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <p style="color:#f00;text-align:right;">
          注：保存后此员工之前配置的权限会被覆盖掉。
        </p>
      </el-form>
    </div>
  </div>
</template>

<script>
import { existenceOrderClerkList, getOrderClerkByUserCodeList, copyPrivilege } from '@/API/index.js';
export default {
  name: 'CopyOrderPerson',
  data () {
    return {
      exitLoading: false,
      form: {
        userNameYet: '',
        userName: ''
      },
      tableData: [],
      tableLoading: false,
      rules: {
        userName: [
          { required: true, message: '请选择员工姓名', trigger: 'change' }
        ],
        userNameYet: [
          { required: true, message: '请选择已有权限的员工姓名', trigger: 'change' }
        ]
      },
      existenceOrderPersonList: []
    };
  },
  props: {
    orderPersonList: {
      type: Array,
      default: () => { return {}; }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    existOrderPersonList () {
      this.exitLoading = true;
      existenceOrderClerkList().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.existenceOrderPersonList = json.data;
          this.exitLoading = false;
        }
      }).catch((res) => {
        this.exitLoading = false;
      });
    },
    getOrderClerkByUserCodeLists (userCode) {
      this.tableLoading = true;
      getOrderClerkByUserCodeList(userCode).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableLoading = false;
          this.tableData = json.data;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    changeUserName (val) {
      this.getOrderClerkByUserCodeLists(val);
    },
    copyOrderPerson () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let userId = '';
          this.orderPersonList.forEach((item) => {
            if (item.userName === this.form.userName) {
              userId = item.userId;
            }
          });
          let params = {
            fromUserId: this.form.userNameYet,
            toUserId: userId,
            toUserName: this.form.userName
          };
          copyPrivilege(params).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$message.success('添加成功');
              this.$emit('isShowCopy', false);
            }
          }).catch((res) => {
            this.$message.warning('添加失败');
            this.$emit('isShowCopy', false);
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted () {
    this.existOrderPersonList();
  }
};
</script>

<style lang="scss">
  .baseInfoForm {
  .el-form-item--mini.el-form-item {
    margin-bottom: 0;
  }
  }
  .baseInfoForm{
  .el-form-item__error{
    position: relative;
  }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
  .copy-order-person{
  .rj-col-1{
    margin-bottom: 10px;
  }
  .el-select{
    width: 100%;
  }
    .rj-baseinfo__item{
      padding-right: 0;
    }
    .tableBody{
      max-height: 200px;
      overflow: auto;
      margin: 20px 0;
      border-top:1px solid #EBECF5 ;
      border-bottom:1px solid #EBECF5 ;
    }
  }
</style>
